import { render, staticRenderFns } from "./OnboardSelfSignedUser.vue?vue&type=template&id=676abe75&"
import script from "./OnboardSelfSignedUser.vue?vue&type=script&lang=js&"
export * from "./OnboardSelfSignedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports